export const ZonesKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@zones-kpis/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@zones-kpis/API_RESPONSE_ERROR',
    GET_AVERAGE_DOMESTIC_ZONE: '@@zones-kpis/GET_AVERAGE_DOMESTIC_ZONE',
    GET_ZONES_COUNT: '@@zones-kpis/GET_ZONES_COUNT',
    GET_DOMESTIC_ZONES_BY_TIMEFRAME: '@@zones-kpis/GET_DOMESTIC_ZONES_BY_TIMEFRAME',
    GET_ZONES_SHIPMENTS_COST: '@@zones-kpis/GET_ZONES_SHIPMENTS_COST',
};
